/**
 * useRicevutaPdfUrl — F-008 Phase 5 (IMPL-P5-004).
 *
 * Recupera la presigned GET URL della ricevuta caricata per renderla in
 * `<iframe>` (anteprima lato operatore — Phase 6 IMPL-P6-003 PDFReceiptPreview).
 * Mirror esatto di `usePdfUrl.ts` (F-007) ma per l'endpoint
 * `/api/v1/operator/:id/ricevuta-pdf-url`.
 *
 * Cache strategy:
 *  - `staleTime: 50_000` — cache valida 50s, sotto il TTL 60s server-side
 *    della presigned GET URL (margine per il render/network roundtrip)
 *  - `gcTime: 65_000`    — la entry resta in cache 65s totali, poi GC
 *  - Entrambi i valori coincidono con `usePdfUrl` per coerenza UX
 *
 * `enabled` è `false` quando `s3Key` è `null` o stringa vuota — case dei
 * pratica DTO senza ricevuta caricata (stato ≠ COMPLETATA o ricevuta non
 * ancora promossa). Il caller (PDFReceiptPreview) ritorna early se s3Key
 * è null, ma l'enabled guard è defense-in-depth: previene network calls a
 * vuoto che fallirebbero comunque server-side con 422 PDF_NOT_FOUND.
 *
 * Query key:
 *   `['operator', 'ricevuta-pdf', s3Key]` — namespace separato da
 *   `['operator', 'pdf-url', praticaId]` (contratto originale) così le due
 *   URL coesistono senza collisioni.
 */
import { useQuery } from '@tanstack/react-query';
import { operatorClient } from '../lib/operator-client';

export function useRicevutaPdfUrl(
  praticaId: string,
  s3Key: string | null | undefined,
) {
  return useQuery({
    queryKey: ['operator', 'ricevuta-pdf', s3Key] as const,
    queryFn: () => operatorClient.getRicevutaPdfUrl(praticaId),
    enabled: Boolean(s3Key),
    staleTime: 50_000,
    gcTime: 65_000,
  });
}
